<!--
  为什么要开通会员
-->
<template>
  <div class="vip-compare">
    <div class="inner_center">
      <h2>为什么要开通会员？</h2>

      <div class="vip-compare-box">
        <!-- 推荐小标 -->
        <div class="icon_recommend">
          <span>推荐</span>
        </div>

        <!-- 创意用户 -->
        <div class="creative-user">
          <div class="title-box">
            <i class="icon_creative" />
            <span>潮国创意用户</span>
          </div>
          <ul class="permission-list">
            <li class="permission-item">海量正版优质图片免费用！</li>
            <li class="permission-item">VIP内容每日免费更新</li>
            <li class="permission-item">作品高速下载通道</li>
            <li class="permission-item">含新媒体、线上、线下等多范围商用授权！商用0风险</li>
          </ul>
        </div>
        <!-- 普通用户 -->

        <div class="normal-user">
          <div class="title-box">
            <span>普通用户</span>
          </div>
          <ul class="permission-list">
            <li class="permission-item">
              <i class="icon_dot"></i>下载内容受限，每日仅限1次
            </li>
            <li class="permission-item"><i class="icon_dot"></i>错过最新更新高品质图片</li>
            <li class="permission-item"><i class="icon_dot"></i>作品普通下载通道</li>
            <li class="permission-item"><i class="icon_dot"></i>正版内容无法商用，存在侵权风险</li>
          </ul>
        </div>

      </div>

      <IntroduceQuestion />
    </div>
  </div>
</template>

<script>
import {serviceLink} from "~/constant/CONFIG";
import IntroduceQuestion from "@/components/_Privately/Introduce/Question"

export default {
  name: "VipCompare",
  components:{
    IntroduceQuestion
  },
  data(){
    return{
      serviceLink
    }
  }
}
</script>

<style lang="scss" scoped>
.vip-compare {
  padding: 72px 0 80px;

  .inner_center{
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  h2 {
    font-size: 36px;
    font-weight: bold;
    color: #2D2B33;
    line-height: 48px;
    letter-spacing: 1px;
    text-align: center;
  }

  .vip-compare-box {
    margin:  65px auto 96px;
    @include BgImage(1034px, 348px, 'introduce/vip-compare-bg.png');
    position: relative;


    .icon_recommend {
      @include BgImage(61px, 34px, 'introduce/icon_recommend.png');
      font-size: 15px;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 34px;
      text-align: center;
    }

    .creative-user{

      @include Position(1,5,64px,52px);
      .title-box{
        display: flex;
        align-items: center;
        margin-bottom: 36px;
        .icon_creative{
          @include BgImage(41px,41px,'introduce/icon_creative-user.png');
          margin-right: 8px;

        }
        span{
          font-size: 24px;
          font-weight: bold;
          color: #FFFFFF;
          line-height: 32px;
          letter-spacing: 1px;
          position: relative;
          z-index: 2;

          &:before{
            content: '';
            display: inline-block;
            width: 148px;
            height: 14px;
            background: linear-gradient(180deg, rgba(162, 162, 255, 0.6) 0%, rgba(162, 162, 255, 0) 100%);
            border-radius: 1px;
            @include Position(1,4,0,-6px);
            z-index: -1;
          }
        }
      }

      .permission-list{
        padding-left: 20px;
        .permission-item{

          font-size: 15px;
          color: #FFFFFF;
          line-height: 20px;
          letter-spacing: 1px;
          margin-bottom: 24px;
          position: relative;

          &:before{
            content: '';
            display: inline-block;
            width: 4px;
            height: 4px;
            background: #FFFFFF;
            border-radius: 50%;
            @include Position(1,5,-12px,50%);
            transform: translateY(-50%);
          }
        }
      }
    }

    .normal-user{
      @include Position(1,2,72px,47px);
      text-align: right;
      .title-box{
        margin-bottom: 41px;
        span{
          font-size: 24px;
          font-weight: 600;
          color: #596088;
          line-height: 33px;
          letter-spacing: 1px;
          position: relative;
          z-index: 5;

          &:before{
            content: '';
            display: inline-block;
            width: 100px;
            height: 14px;
            background: linear-gradient(180deg, #A6BADD 0%, rgba(210, 220, 238, 0) 100%);
            border-radius: 1px;
            @include Position(1,4,0,-6px);
            z-index: -1;
          }
        }
      }

      .permission-list{
        display: flex;
        flex-direction: column;
        .permission-item{
          font-size: 15px;
          color: #596088;
          line-height: 20px;
          letter-spacing: 1px;
          margin-bottom: 24px;
          display: inline-flex;
          align-items: center;
          justify-content: flex-end;

          .icon_dot{
            display: inline-block;
            width: 4px;
            height: 4px;
            line-height: 20px;
            background: #596088;
            border-radius: 50%;
            margin-right: 8px;
          }

          /*&:before{
            content: '';
            display: inline-block;
            width: 4px;
            height: 4px;
            background: #596088;
            border-radius: 50%;
            @include Position(1,5,-8px,50%);
            transform: translateY(-50%);
          }*/
        }
      }
    }
  }


  .problem-list{
    display: flex;
    flex-wrap: wrap;
    margin-top: 64px;
    .problem-item{
      width: 540px;
      margin-bottom: 40px;
      margin-right: 120px;

      &:nth-child(2n){
        margin-right: 0;
      }

      .problem-title{
        font-size: 20px;
        font-weight: bold;
        color: #0A2540;
        line-height: 27px;
        letter-spacing: 1px;
        margin-bottom: 16px;
      }

      .problem-content{
        font-size: 14px;
        color: #596088;
        line-height: 24px;

        .service{
          font-size: 14px;
          color: #6969FF;
          line-height: 24px;
          text-decoration: underline;
        }
      }
    }

  }
}
</style>
